import React, { useState, useEffect, createRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import './Modal.css';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
// import './Modal.css';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));



const Loader = (props) => {
  
    const [open, setOpen] = React.useState(true);
    const handleClose = () => {
      setOpen(false);
    };
    const handleToggle = () => {
      setOpen(!open);
    };
 

    return (
       

<Modal show={open} onHide={handleClose} size="sm" dialogClassName="loader"  backdrop="static" keyboard={false}>
<div style={{display:"flex",margin:"auto"}} >
<CircularProgress  />

</div>
</Modal>

      
   /*   <React.Fragment>
       <Backdrop className={useStyles.backdrop} open={open} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
      </React.Fragment> */

    );

}

export default Loader;

